import { useState } from "react";
import styled from "styled-components";

const Container = styled.div`
  width: 500px;
  margin: 20px auto;
  text-align: center;
  padding: 20px;
`;

const Button = styled.button<{ loading: boolean }>`
  background: #3b6255;
  color: #fff;
  padding: 12px 24px;
  border-radius: 6px;
  cursor: ${({ loading }) => (loading ? "not-allowed" : "pointer")};
  border: none;
  font-size: 16px;
  font-weight: bold;
`;

const Message = styled.p<{ success: boolean }>`
  margin-top: 12px;
  font-size: 12px;
  font-family: 'IBM Plex Mono';
  font-weight: 700;
  color: ${({ success }) => (success ? "#3B6255" : "#AE0505")};
`;

export const ResendVerificationButton: React.FC<{ email: string }> = ({
  email,
}) => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  const handleResend = async () => {
    setLoading(true);
    setMessage(null);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API_URL}/auth/resend-verification-email`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        }
      );
      const data = await response.json();
      if (!response.ok)
        throw new Error(data.error || "Помилка повторної відправки");
      setMessage("✅ Лист повторно надіслано!");
    } catch (err: any) {
      setMessage(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Button onClick={handleResend} loading={loading}>
        {loading ? "Надсилаю..." : "Надіслати лист повторно"}
      </Button>
      {message && (
        <Message success={message.startsWith("✅")}>{message}</Message>
      )}
    </Container>
  );
};
